import React, { Component } from 'react'
import { ResponsiveLine } from '@nivo/line'
import './ChartLine.scss'

const data = [
  {
    "id": "whisky",
    "color": "hsl(334, 70%, 50%)",
    "data": [
      {
        "color": "hsl(212, 70%, 50%)",
        "x": "SR",
        "y": 6
      },
      {
        "color": "hsl(235, 70%, 50%)",
        "x": "IR",
        "y": 8
      },
      {
        "color": "hsl(57, 70%, 50%)",
        "x": "AX",
        "y": 30
      },
      {
        "color": "hsl(110, 70%, 50%)",
        "x": "BJ",
        "y": 2
      },
      {
        "color": "hsl(198, 70%, 50%)",
        "x": "TL",
        "y": 20
      },
      {
        "color": "hsl(203, 70%, 50%)",
        "x": "YE",
        "y": 21
      },
      {
        "color": "hsl(262, 70%, 50%)",
        "x": "TT",
        "y": 40
      },
      {
        "color": "hsl(198, 70%, 50%)",
        "x": "SA",
        "y": 23
      },
      {
        "color": "hsl(341, 70%, 50%)",
        "x": "SB",
        "y": 25
      }
    ]
  },
  {
    "id": "rhum",
    "color": "hsl(74, 70%, 50%)",
    "data": [
      {
        "color": "hsl(154, 70%, 50%)",
        "x": "SR",
        "y": 9
      },
      {
        "color": "hsl(210, 70%, 50%)",
        "x": "IR",
        "y": 57
      },
      {
        "color": "hsl(286, 70%, 50%)",
        "x": "AX",
        "y": 20
      },
      {
        "color": "hsl(106, 70%, 50%)",
        "x": "BJ",
        "y": 15
      },
      {
        "color": "hsl(182, 70%, 50%)",
        "x": "TL",
        "y": 49
      },
      {
        "color": "hsl(334, 70%, 50%)",
        "x": "YE",
        "y": 53
      },
      {
        "color": "hsl(160, 70%, 50%)",
        "x": "TT",
        "y": 59
      },
      {
        "color": "hsl(266, 70%, 50%)",
        "x": "SA",
        "y": 59
      },
      {
        "color": "hsl(128, 70%, 50%)",
        "x": "SB",
        "y": 23
      }
    ]
  },
  {
    "id": "gin",
    "color": "hsl(319, 70%, 50%)",
    "data": [
      {
        "color": "hsl(228, 70%, 50%)",
        "x": "SR",
        "y": 20
      },
      {
        "color": "hsl(341, 70%, 50%)",
        "x": "IR",
        "y": 56
      },
      {
        "color": "hsl(137, 70%, 50%)",
        "x": "AX",
        "y": 8
      },
      {
        "color": "hsl(304, 70%, 50%)",
        "x": "BJ",
        "y": 39
      },
      {
        "color": "hsl(179, 70%, 50%)",
        "x": "TL",
        "y": 40
      },
      {
        "color": "hsl(285, 70%, 50%)",
        "x": "YE",
        "y": 18
      },
      {
        "color": "hsl(354, 70%, 50%)",
        "x": "TT",
        "y": 58
      },
      {
        "color": "hsl(124, 70%, 50%)",
        "x": "SA",
        "y": 52
      },
      {
        "color": "hsl(93, 70%, 50%)",
        "x": "SB",
        "y": 26
      }
    ]
  },
  {
    "id": "vodka",
    "color": "hsl(344, 70%, 50%)",
    "data": [
      {
        "color": "hsl(93, 70%, 50%)",
        "x": "SR",
        "y": 7
      },
      {
        "color": "hsl(310, 70%, 50%)",
        "x": "IR",
        "y": 9
      },
      {
        "color": "hsl(296, 70%, 50%)",
        "x": "AX",
        "y": 23
      },
      {
        "color": "hsl(5, 70%, 50%)",
        "x": "BJ",
        "y": 47
      },
      {
        "color": "hsl(245, 70%, 50%)",
        "x": "TL",
        "y": 29
      },
      {
        "color": "hsl(147, 70%, 50%)",
        "x": "YE",
        "y": 12
      },
      {
        "color": "hsl(148, 70%, 50%)",
        "x": "TT",
        "y": 49
      },
      {
        "color": "hsl(99, 70%, 50%)",
        "x": "SA",
        "y": 41
      },
      {
        "color": "hsl(8, 70%, 50%)",
        "x": "SB",
        "y": 52
      }
    ]
  },
  {
    "id": "cognac",
    "color": "hsl(120, 70%, 50%)",
    "data": [
      {
        "color": "hsl(160, 70%, 50%)",
        "x": "SR",
        "y": 2
      },
      {
        "color": "hsl(337, 70%, 50%)",
        "x": "IR",
        "y": 34
      },
      {
        "color": "hsl(11, 70%, 50%)",
        "x": "AX",
        "y": 43
      },
      {
        "color": "hsl(177, 70%, 50%)",
        "x": "BJ",
        "y": 38
      },
      {
        "color": "hsl(267, 70%, 50%)",
        "x": "TL",
        "y": 47
      },
      {
        "color": "hsl(103, 70%, 50%)",
        "x": "YE",
        "y": 56
      },
      {
        "color": "hsl(120, 70%, 50%)",
        "x": "TT",
        "y": 20
      },
      {
        "color": "hsl(252, 70%, 50%)",
        "x": "SA",
        "y": 10
      },
      {
        "color": "hsl(264, 70%, 50%)",
        "x": "SB",
        "y": 50
      }
    ]
  }
]

class ChartLine extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
          <div style={{height: this.props.height}}>
          <ResponsiveLine
            data={data}
            margin={{
                "top": 50,
                "right": 110,
                "bottom": 50,
                "left": 60
            }}
            minY="auto"
            stacked={true}
            axisBottom={{
                "orient": "bottom",
                "tickSize": 5,
                "tickPadding": 5,
                "tickRotation": 0,
                "legend": "country code",
                "legendOffset": 36,
                "legendPosition": "center"
            }}
            axisLeft={{
                "orient": "left",
                "tickSize": 5,
                "tickPadding": 5,
                "tickRotation": 0,
                "legend": "count",
                "legendOffset": -40,
                "legendPosition": "center"
            }}
            colors="d320"
            dotSize={10}
            dotColor="inherit:darker(0.3)"
            dotBorderWidth={2}
            dotBorderColor="#ffffff"
            enableDotLabel={true}
            dotLabel="y"
            dotLabelYOffset={-12}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            legends={[
                {
                    "anchor": "bottom-right",
                    "direction": "column",
                    "translateX": 100,
                    "itemWidth": 80,
                    "itemHeight": 20,
                    "symbolSize": 12,
                    "symbolShape": "circle"
                }
            ]}
        />
          </div>
        )
    }
}

export default ChartLine



// WEBPACK FOOTER //
// ./src/views/components/ChartLine/index.js